import { useEffect, useState } from 'react'
import { applyTheme, resolveTheme, storeChoice, storedChoice, type ThemeChoice } from '../lib/theme'
import { MoonIcon, SunIcon } from './Icons'

/**
 * Umschalter Dark/Light. Die dritte Stellung "System" folgt der
 * Betriebssystemeinstellung, wie docs/design.md es verlangt.
 */
export function ThemeToggle() {
  const [choice, setChoice] = useState<ThemeChoice>(() => storedChoice())

  useEffect(() => {
    applyTheme(choice)
    if (choice !== 'system') return
    const mq = window.matchMedia('(prefers-color-scheme: light)')
    const onChange = () => applyTheme('system')
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [choice])

  const next: ThemeChoice = choice === 'system' ? 'light' : choice === 'light' ? 'dark' : 'system'
  const labels: Record<ThemeChoice, string> = {
    system: 'System',
    light: 'Hell',
    dark: 'Dunkel',
  }

  return (
    <button
      type="button"
      className="btn btn-sm"
      data-testid="theme-toggle"
      aria-label={`Farbschema: ${labels[choice]}. Weiter zu ${labels[next]}`}
      onClick={() => {
        storeChoice(next)
        setChoice(next)
      }}
    >
      {resolveTheme(choice) === 'light' ? <SunIcon /> : <MoonIcon />}
      <span>{labels[choice]}</span>
    </button>
  )
}
